import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import OOSBuyOption from "web/react/components/oos-buy-option/oos-buy-option";
import { BuyOptionPropType } from "web/types/buy-option";
import styles from "./oos-buy-options-rail.css";


function OOSBuyOptionsRail({ buyOptions, className, sortedBuyOptions, previouslySeenTitle }) {
    return (
        <Rail
            className={className}
            title={previouslySeenTitle}
            analyticsLabel={"oos_buy_options"}
            smallRail={true}
        >
            {sortedBuyOptions.map((linkId) => {
                const buyOption = buyOptions[linkId];
                return (
                    <OOSBuyOption
                        buyOption={buyOption}
                        isWide={sortedBuyOptions.length <= 2}
                        key={buyOption.link_id}
                        className={styles.buyOption}
                    />
                );
            })}
        </Rail>
    );
}

OOSBuyOptionsRail.propTypes = {
    buyOptions: PropTypes.objectOf(BuyOptionPropType).isRequired,
    className: PropTypes.string,
    sortedBuyOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
    previouslySeenTitle: PropTypes.string.isRequired,
};

export default OOSBuyOptionsRail;
